import * as React from "react";
import {Stack} from "@mui/material";
import ScreenWrapper from "crqlar-react-common/dist/components/ScreenWrapper";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {RateService} from "crqlar-react-common/dist/services/rate/rate.service";
import {Service} from "crqlar-react-common/dist/models/service/service.model";
import RatePreview from "crqlar-react-common/dist/components/RatePreview";

interface Props {
    service: Service
    updateField: (field: keyof Service, value: any) => void
    disabled?: boolean
    titleSection?: React.ReactNode
}

const ServiceRatesTab = (props: Props) => {

    const {t} = useLocalize()
    const service = props.service
    const updateField = props.updateField
    const disabled = props.disabled
    const titleSection = props.titleSection

    const ratesSection = (
        <RatePreview
            entityId={service.id}
            rateIds={service.rateIds}
            noEntityTitle={t('Please save the service to set up rates')}
            noRatesMessage={t('This service has no rates set')}
            onRemove={rateId => {
                const newRates = service.rateIds?.filter(r => r !== rateId)
                updateField('rateIds', newRates)
            }}
            onAdd={async rate => {
                let rateId = rate.id

                if (!rateId) {
                    const newRate = await RateService.createRate(rate)
                    rateId = newRate.id
                }

                const newRates = service.rateIds?.filter(r => r !== rateId) || []
                newRates.push(rateId!!)
                updateField('rateIds', newRates)
            }}
            defaultRateName={[service.name, 'price'].filter(Boolean).join(' ')}
            disabled={disabled}
        />
    )

    return(

        <ScreenWrapper>

            <Stack
                sx={{
                    width: '100%',
                    maxWidth: '900px',
                    gap: 1,
                    alignSelf: 'center'
                }}
            >
                {titleSection}
                {ratesSection}
            </Stack>

        </ScreenWrapper>

    )
}

export default ServiceRatesTab
